// extracted by mini-css-extract-plugin
export default {"termsContent":"IdPreferences_termsContent__Zgl5n"};